import React, { Component } from "react";
import { Grid, Col, Row } from "react-bootstrap";
import Header from "./Header.jsx";
import Banner from "./Banner.jsx";
import BackButton from "./BackButton.jsx";
import InnovationAreasGrid from "./InnovationAreasGrid.jsx";
import hyperlinks from "../../../src/util/hyperlinks";

export default class InnovationAreas extends Component {
    render() {
        return (
            <Header showCorporateMembers={this.props.showCorporateMembers} flashes={this.props.flashes} currentUser={this.props.currentUser}>
                <Grid className="with-background innovation-areas-page">
                    <Banner heading="Innovation Areas" />
                    <BackButton href={hyperlinks["home"]} text="❮ Home" />
                    <Row>
                        <Col className="innovation-areas-content" md={10} mdOffset={1}>
                            <h2>What is an innovation area?</h2>

                            <p>
                                To become a utility member of the Leading Utilities of the World, a utility needs to demonstrate outstanding innovation in at least three areas of utility management (referred to here as 'innovation areas') and have an ambition to continue to drive performance in the years to come.
                            </p>

                            <p>
                                These areas are designed to apply comprehensively to water utilities, specifically in economically developed countries, and enable utilities to understand the commonalities of challenges and solutions that are relevant across different local, social, political, environmental, and regulatory frameworks.
                            </p>

                            <p>
                                Click on the innovation areas below to explore the innovations of current utility members:
                            </p>
                        </Col>
                    </Row>
                    <InnovationAreasGrid innovationAreas={this.props.innovationAreas} />
                </Grid>
            </Header>
        );
    }
}



// WEBPACK FOOTER //
// ./app/javascript/components/InnovationAreas.jsx.erb